import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "@/data/content";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const isActive = (to) => location.pathname.startsWith(to);

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-m61-bg/80 backdrop-blur-xl border-b border-m61-line">
      <div className="m61-container flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3" aria-label="Meta61 — home" data-testid="nav-logo">
          <img src="/meta61-icon.png" alt="Meta61" className="w-10 h-10 object-contain" width="40" height="40" />
          <span className="font-display text-lg font-semibold tracking-tight text-m61-text">Meta61</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={() =>
                `text-sm tracking-wide transition-colors ${isActive(l.to) ? "text-m61-cyan" : "text-m61-muted hover:text-m61-text"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact" className="m61-btn-primary" data-testid="nav-contact-cta">Contact</Link>
        </nav>

        <button className="lg:hidden p-2 text-m61-text" onClick={() => setOpen(!open)} aria-label="Toggle navigation" aria-expanded={open} data-testid="nav-mobile-toggle">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-m61-line bg-m61-bg">
          <div className="m61-container py-6 space-y-2">
            {NAV_LINKS.map((l) => (
              <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)}
                className={() => `block py-2 text-base ${isActive(l.to) ? "text-m61-cyan" : "text-m61-text"}`}>
                {l.label}
              </NavLink>
            ))}
            <Link to="/contact" onClick={() => setOpen(false)} className="m61-btn-primary w-full justify-center mt-4">Contact</Link>
          </div>
        </div>
      )}
    </header>
  );
}
